<template>
  <div>
    <div class="table-wrapper" ref="contentWrapperScroll">
      <table>
        <caption class="visually-hidden">
          {{
            $t('WHATSAPP_CONSUMPTIONS_REPORT.HEADER_DETAIL')
          }}
        </caption>
        <thead>
          <tr>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.MSG_CREATED_AT') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.CONTACT_NAME') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.PHONE_NUMBER') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.INBOX') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.TEMPLATE_NAME') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.CATEGORY') }}</th>
            <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.MESSAGE_LINK') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(msg, index) in paginatedData"
            :key="index"
            :class="{ 'striped-row': index % 2 !== 0 }"
          >
            <td>{{ formatDate(msg.msg_created_at) }}</td>
            <td>{{ msg.contact_name || '-' }}</td>
            <td>{{ msg.phone_number || '-' }}</td>
            <td>{{ msg.inbox_name || '-' }}</td>
            <td>{{ msg.template_name || '-' }}</td>
            <td>{{ msg.category || '-' }}</td>
            <td>
              <a
                :href="msg.link_conversation"
                target="_blank"
                rel="noopener"
                :title="msg.link_conversation"
              >
                {{ truncateLink(msg.link_conversation) }}
              </a>
            </td>
          </tr>
          <tr v-if="loading">
            <td colspan="7">
              <spinner :colorScheme="'dark'" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.PAGE') }}
        {{ currentPage }} {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.COMMON.OF') }}
        {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  
  </div>
</template>

<script>

import Spinner from 'shared/components/Spinner.vue';

export default {
  name: 'WhatsappEventsDetailsTable',
  components: {    
    Spinner
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.events.slice(start, start + this.perPage);
    },
    totalPages() {
      if(this.events.length < this.perPage){
        return 1;
      }
      return Math.ceil(this.events.length / this.perPage);
    },
  },
  watch: {
    events: {
      handler() {
        this.currentPage = 1;
      },
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        if (this.$refs.contentWrapperScroll) {
          this.$refs.contentWrapperScroll.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });

        }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr.split('+')[0]);
      return date.toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      });
    },
    truncateLink(link, maxLength = 30) {
      if (!link) return '';
      if (link.length <= maxLength) return link;
      return link.slice(0, maxLength) + '...';
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>